import { useNavigate, useParams } from "react-router-dom";
import React from "react";
import { useLazySubAdminByIdQuery } from "../../services/subAdmin";
import usePermission from "../../hooks/userAccess";

const SubadminDetail = () => {
  const navigate = useNavigate();
  const { id } = useParams();

  const { isView } = usePermission({
    label: 'Manage Sub-Admin',
    page_permission: 'isView',
  })

  const [triggerGetById, { isFetching }] = useLazySubAdminByIdQuery();
  const [detail, setDetail] = React.useState<any>(null);

  React.useEffect(() => {
    const fetchDetail = async () => {
      if (!id) return;
      try {
        const res: any = await triggerGetById({ id }).unwrap();
        setDetail(res?.data || res);
      } catch (e) {
        setDetail(null);
      }
    };
    fetchDetail();
  }, [id, triggerGetById]);

  return (
    <>
      <div className="main_title">
        <h1>Sub-Admin Detail</h1>
        <p>
          <button onClick={() => navigate("/dashboard")}>Dashboard</button>
          {' '} - <button onClick={() => navigate(-1)}>Manage Sub-Admin</button>
          {' '} - Sub-Admin Detail
        </p>
      </div>

      {isView && <div className="cards view_page">
        <div className="gap_p">
          <div className="vew_img w_100">
            <h6>Image</h6>
            <figure>
              <img alt="user" src={detail?.image || "/static/images/user_placeholder.png"} />
            </figure>
          </div>
          <div className="w_33">
            <h6>Name</h6>
            <p>{detail?.fullName || detail?.name || '-'}</p>
          </div>
          <div className="w_33">
            <h6>Email Id</h6>
            <p>{detail?.email || '-'}</p>
          </div>
          <div className="w_33">
            <h6>Phone Number</h6>
            <p>{detail?.dialCode ? `+${String(detail.dialCode).replace(/^\+/, '')}` : ''}{detail?.phoneNo || detail?.phone || '-'}</p>
          </div>
          <div className="w_33">
            <h6>Role</h6>
            <p>{detail?.accessRole ? detail?.accessRole?.name : '-'}</p>
          </div>
          <div className="w_33">
            <h6>Created Date</h6>
            <p>{detail?.createdAt ? new Date(detail.createdAt).toLocaleDateString() : '-'}</p>
          </div>
        </div>
      </div>}
    </>
  );
};

export default SubadminDetail;
